import { ScrollViewProps } from '@bonanza-social/moonlight';

export const MIN_DOCUMENTS_LENGTH = 2;
export const MAX_DOCUMENTS_LENGTH = 4;

export const CONTENT_CONTAINER_STYLE: Required<ScrollViewProps>['contentContainerStyle'] =
  {
    gap: 'space-400',
    paddingVertical: 'space-400',
  };
